export type TierSlug = "operator_plan" | "analyst_plan" | "command_plan";

export type TierLimits = {
  slug: TierSlug;
  priceId: string;
  name: string;
  monthlyUsd: number;
  tagline: string;
  scansPerMonth: number; // -1 = unlimited
  aiQueriesPerMonth: number; // -1 = unlimited
  dossiersPerMonth: number; // -1 = unlimited
  vaultRetentionDays: number; // -1 = forever
  features: { label: string; included: boolean }[];
  highlighted?: boolean;
};

export const TIERS: Record<TierSlug, TierLimits> = {
  operator_plan: {
    slug: "operator_plan",
    priceId: "operator_monthly",
    name: "Operator",
    monthlyUsd: 29,
    tagline: "For solo investigators getting started.",
    scansPerMonth: 25,
    aiQueriesPerMonth: 25,
    dossiersPerMonth: 5,
    vaultRetentionDays: 30,
    features: [
      { label: "25 OSINT scans per month", included: true },
      { label: "AI assistant — 25 messages / month", included: true },
      { label: "5 PDF dossier exports / month", included: true },
      { label: "30-day Vault retention", included: true },
      { label: "Live threat & geo feeds", included: true },
      { label: "Private source connectors", included: false },
      { label: "Priority compute & team seats", included: false },
    ],
  },
  analyst_plan: {
    slug: "analyst_plan",
    priceId: "analyst_monthly",
    name: "Analyst",
    monthlyUsd: 149,
    tagline: "For active analysts running real casework.",
    scansPerMonth: 250,
    aiQueriesPerMonth: 300,
    dossiersPerMonth: 100,
    vaultRetentionDays: 365,
    highlighted: true,
    features: [
      { label: "250 OSINT scans per month", included: true },
      { label: "AI assistant — 300 messages / month", included: true },
      { label: "100 PDF dossier exports / month", included: true },
      { label: "1-year Vault retention", included: true },
      { label: "Private source connectors", included: true },
      { label: "Entity graphs & threat monitoring", included: true },
      { label: "Priority compute & team seats", included: false },
    ],
  },
  command_plan: {
    slug: "command_plan",
    priceId: "command_monthly",
    name: "Command",
    monthlyUsd: 599,
    tagline: "For teams and command centers.",
    scansPerMonth: -1,
    aiQueriesPerMonth: -1,
    dossiersPerMonth: -1,
    vaultRetentionDays: -1,
    features: [
      { label: "Unlimited OSINT scans", included: true },
      { label: "Unlimited AI assistant queries", included: true },
      { label: "Unlimited PDF report exports", included: true },
      { label: "Permanent Vault retention", included: true },
      { label: "Private source connectors", included: true },
      { label: "Priority compute lane", included: true },
      { label: "Team seats & admin console", included: true },
    ],
  },
};

export const TIER_ORDER: TierSlug[] = ["operator_plan", "analyst_plan", "command_plan"];

export function tierFromProductId(productId: string | null | undefined): TierLimits | null {
  if (!productId) return null;
  return (TIERS as Record<string, TierLimits>)[productId] ?? null;
}